import * as Yup from 'yup'
import { schema } from '../../../utils/schemaValidation'
import { getInitialState } from '../../../utils/formikUpdate'

export const datasetFormik = async () => {
  const ITEMS_FAMILY_FORMIK = [
    {
      x: 12,
      name: 'family_',
      initvalue: '',
      label: 'Familia',
    },
    {
      x: 12,
      name: 'estado_validacion',
      initvalue: 'verificado',
      label: 'Estado de validación',
      options: { verificado: 'Verificado', pendiente: 'Pendiente' },
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_FAMILY_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({ ...schema.FAMILY })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_FAMILY_FORMIK,
    FORM_VALIDATION,
  }
}
